module.exports = __webpack_public_path__ + "img/top-2-5.425668d3.jpg";